import { Component } from 'react';
import MDCList, {
	ListItem as MDCListItem,
	ListItemText as MDCListItemText,
	ListDivider as MDCListDivider,
	ListGroup as MDCListGroup,
	ListGroupSubheader as MDCListGroupSubheader,
	ListItemGraphic as MDCListItemGraphic,
	ListItemMeta as MDCListItemMeta,
} from '@material/react-list';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from './List.module.scss';
const STYLE_SMALL = 'mdc-list--small';
const STYLE_MEDIUM = 'mdc-list--medium';
const STYLE_LARGE = 'mdc-list--large';
const STYLE_XLARGE = 'mdc-list--xlarge';
const STYLE_LIST_ITEM = 'mdc-list-item';

class List extends Component {
	render() {
		let classesList = classNames(this.props.className, {
			[`${classes[STYLE_SMALL]}`]: this.props.small,
			[`${classes[STYLE_MEDIUM]}`]: this.props.medium,
			[`${classes[STYLE_LARGE]}`]: this.props.large,
			[`${classes[STYLE_XLARGE]}`]: this.props.xlarge,
		});

		let props = { ...this.props };
		const propIndi = ['className', 'small', 'medium', 'large', 'xlarge'];
		propIndi.map(el => delete props[el]);

		return (
			<MDCList {...props} className={classesList}>
				{props.children}
			</MDCList>
		);
	}
}

const ListItem = props => {
	let propsLocal = { ...props };
	const propIndi = ['className'];
	propIndi.map(el => delete propsLocal[el]);

	return (
		<MDCListItem
			{...propsLocal}
			className={[classes[STYLE_LIST_ITEM], props.className].join(' ')}
		/>
	);
};

const isSized = (props, propName, componentName) => {
	const SMALL = 'small';
	const MEDIUM = 'medium';
	const LARGE = 'large';
	const XLARGE = 'xlarge';

	if (
		!props.hasOwnProperty(SMALL) &&
		!props.hasOwnProperty(MEDIUM) &&
		!props.hasOwnProperty(LARGE) &&
		!props.hasOwnProperty(XLARGE)
	) {
		return new Error(
			'Failed prop type: The prop `' +
				SMALL +
				'`, prop `' +
				MEDIUM +
				'`, prop `' +
				LARGE +
				'` OR prop `' +
				XLARGE +
				'` is marked as required in `' +
				componentName +
				'`, but its value is `undefined`.'
		);
	} else {
		if (props.hasOwnProperty(propName)) {
			const type = typeof props[propName];
			if (!(type === 'boolean')) {
				return new Error(
					'Failed prop type: Invalid prop `' +
						propName +
						'` of type `' +
						type +
						'` supplied to `' +
						componentName +
						'`, expected `bool`.'
				);
			}
		}
	}

	return;
};

const isVertOrHor = (props, propName, componentName) => {
	const VERT = 'vertical';
	const HOR = 'horizontal';
	if (props.hasOwnProperty(propName)) {
		const val = props[propName];
		if (!(val === VERT || val === HOR)) {
			return new Error(
				'Failed prop type: Invalid prop `' +
					propName +
					'` of value `' +
					val +
					'` supplied to `' +
					componentName +
					'`, expected `' +
					VERT +
					'` or `' +
					HOR +
					'`.'
			);
		}
	}

	return;
};

// documentation: https://github.com/material-components/material-components-web-react/tree/master/packages/list#props
List.propTypes = {
	avatarList: PropTypes.bool,
	checkboxList: PropTypes.bool,
	className: PropTypes.string,
	dense: PropTypes.bool,
	handleSelect: PropTypes.func,
	large: isSized,
	medium: isSized,
	nonInteractive: PropTypes.bool,
	orientation: isVertOrHor,
	radioList: PropTypes.bool,
	selectedIndex: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.number),
		PropTypes.number,
	]),
	singleSelection: PropTypes.bool,
	small: isSized,
	tag: PropTypes.string,
	twoLine: PropTypes.bool,
	wrapFocus: PropTypes.bool,
	xlarge: isSized,
};

export {
	ListItem,
	MDCListItemText,
	MDCListDivider,
	MDCListGroup,
	MDCListGroupSubheader,
	MDCListItemGraphic,
	MDCListItemMeta,
};
export default List;
